import { render, staticRenderFns } from "./changeNewPassword.vue?vue&type=template&id=123ecffc&scoped=true"
import script from "./changeNewPassword.vue?vue&type=script&lang=js"
export * from "./changeNewPassword.vue?vue&type=script&lang=js"
import style0 from "./changeNewPassword.vue?vue&type=style&index=0&id=123ecffc&prod&lang=less&scoped=true"
import style1 from "./changeNewPassword.vue?vue&type=style&index=1&id=123ecffc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123ecffc",
  null
  
)

export default component.exports